/**
 * Races a promise with a timeout and returns a promise that resolves to the value of the original promise or rejects with an error if the timeout is reached
 *
 * @param promise - The promise to wrap.
 * @param ms - The timeout in milliseconds.
 * @param label - The label to use for the error message.
 * @returns The promise.
 */

const withTimeout = <T>(promise: Promise<T>, ms: number, label: string): Promise<T> =>
  Promise.race([
    promise,
    new Promise<T>((_, reject) => {
      setTimeout(() => reject(new Error(`${label} timed out after ${ms}ms`)), ms);
    }),
  ]);

export default withTimeout;
